import { createColumnHelper } from "@tanstack/react-table";
import { IPMSCode } from "./utils/PMSCode-utils";
import PMSCodeActionButton from "./utils/PMSCodeActionsButtons";
import Chip from "@mui/material/Chip";
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";

const columnHelper = createColumnHelper<IPMSCode>();

const PMSCodeColumns = () => {
  const hasEditPermission = usePermission(
    Modules.mmdPms.accessKey,
    Permissions.edit
  );
  const hasDeletePermission = usePermission(
    Modules.mmdPms.accessKey,
    Permissions.delete
  );

  return [
    columnHelper.accessor("id", {
      id: "id",
      header: "Item No",
      cell: ({ row }) => row.index + 1,
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("model", {
      id: "model",
      header: "model",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("smrOdometerInterval", {
      id: "smrOdometerInterval",
      header: "SMR Odemeter Interval",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("pmCodeDescription", {
      id: "pmCodeDescription",
      header: "PMCode Description",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("isActive", {
      id: "isActive",
      header: "Status",
      cell: (row) => (
        <Chip
          label={row.getValue() ? "Active" : "Inactive"}
          color={row.getValue() ? "primary" : "warning"}
          style={{ color: row.getValue() ? "white" : "white", height: "25px" }}
        />
      ),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasEditPermission || hasDeletePermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => <PMSCodeActionButton PMSCode={row.original} hasEditPermission={hasEditPermission} hasDeletePermission={hasDeletePermission} />,
            enableHiding: false,
          }),
        ]
      : []),
  ];
};

export default PMSCodeColumns;
